import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { PlayerDetails } from 'src/app/interfaces/player.interfaces';
import { ScanObject } from 'src/app/interfaces/scan.interfaces';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-player-detail',
  templateUrl: './player-detail.component.html',
})
export class PlayerDetailComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private id: number;
  playerDetails: PlayerDetails | undefined;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.id = -1;
    this.subscription = this.route.paramMap.subscribe((params) => {
      this.id = Number.parseInt(params.get('id') || '-1');
      this.loadPlayer();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getColonyImage(colony: ScanObject): string {
    return environment.imageUrl + '/planets/' + colony.image + '.gif';
  }

  getShipsImage(ship: ScanObject): string {
    return environment.imageUrl + '/ships/' + ship.image + '.gif';
  }

  async loadPlayer() {
    if (this.id < 0) {
      return;
    }
    try {
      this.playerDetails = await this.apiService.fetchPlayer(this.id);
    } catch (error) {
      handleApiError(this.authService, this.router, error);
    }
  }
}
